<template>
  <button class="TextButton" :class="[size, { inline }]">
    <LinkArrow class="icon arrow" v-if="mode === 'arrow'" />
    <LinkArrowHover class="icon arrow-hover" v-if="mode === 'arrow'" />
    <span class="text">{{ text }}</span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { LinkArrow, LinkArrowHover } from '@ka-nabellinc/ka-nabell-icons'

export default defineComponent({
  components: {
    LinkArrow,
    LinkArrowHover,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    mode: {
      type: String as () => 'default' | 'arrow',
      default: 'default'
    },
    size: {
      type: String as () => 'xs' | 'sm' | 'md' | 'lg' | 'xl',
      default: 'md'
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped>
.TextButton {
  display: flex;
  align-items: center;
  gap: 2px;
  border: none;
  padding: 0;
  cursor: pointer;
  background-color: transparent;
}

.TextButton .text {
  color: var(--semantic-colors-text-black);
  font-weight: 400;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-underline-offset: 2px;
  /* Figmaでは「auto」になっているが、デザイン調整の結果「2px」とした */
}

.TextButton:hover .text {
  color: var(--semantic-colors-text-gray);
}

.TextButton.xl .text {
  font-size: var(--font-size-sub-headline-2);
  line-height: 150%;
  letter-spacing: 0.15px;
}

.TextButton.lg .text {
  font-size: var(--font-size-body-1);
  line-height: 150%;
  letter-spacing: 0.14px;
}

.TextButton.md .text {
  font-size: var(--font-size-body-2);
  line-height: 150%;
  letter-spacing: 0.13px;
}

.TextButton.sm .text {
  font-size: var(--font-size-capture-1);
  line-height: 150%;
  letter-spacing: 0.12px;
}

.TextButton.xs .text {
  font-size: var(--font-size-capture-2);
  line-height: 160%;
  letter-spacing: 0.11px;
}

.TextButton.inline {
  display: inline-flex;
}

.TextButton.inline .text {
  color: var(--semantic-colors-text-link);
}

.TextButton.inline:hover .text {
  color: var(--semantic-colors-text-link-hover);
}

.TextButton .arrow-hover {
  display: none;
}

.TextButton:hover .arrow {
  display: none;
}

.TextButton:hover .arrow-hover {
  display: inline-block;
}

.icon {
  position: relative;
}

.TextButton.xs .icon {
  width: 17.6px;
  height: 17.6px;
}

.TextButton.sm .icon {
  width: 18px;
  height: 18px;
}

.TextButton.md .icon {
  width: 19.5px;
  height: 19.5px;
  top: 1.5px;
}

.TextButton.lg .icon {
  width: 21px;
  height: 21px;
  top: 2.5px;
}

.TextButton.xl .icon {
  width: 22.5px;
  height: 22.5px;
  top: 3.5px;
}
</style>